export default __webpack_public_path__ + "static/iguaza-falls-2aee06829536e9d120b7c6abf431d134.jpg";